import * as Diagram from "../../../../components/diagram";

export const EstablishCaseVisitList = {
  label: "立案期間訪視清單",
  key: "EstablishCaseVisitList",
  path: "BoneMuscleCare/EstablishCaseVisitList",
  api: "TCS_V_VisitListV",
  render: (options) => (
    <Diagram.BoneMuscleCare.EstablishCaseVisitList {...options} />
  ),
  isRaw: true,
  isPage: true,
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "開案日期", type: "date" },
    { key: "鄉鎮", type: "string" },
    { key: "訪視區間", type: "string" },
  ],
  columns: [
    {
      key: "案號",
      field: "案號",
      header: "案號",
    },
    {
      key: "個案姓名",
      field: "個案姓名",
      header: "個案姓名",
    },
    {
      key: "身分證號",
      field: "身分證號",
      header: "身分證號",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "篩檢日期",
      field: "篩檢日期",
      header: "篩檢日期",
    },
    {
      key: "開案日期",
      field: "開案日期",
      header: "開案日期",
    },
    {
      key: "最近訪視日期",
      field: "最近訪視日期",
      header: "最近訪視日期",
    },
    {
      key: "下次訪視日期",
      field: "下次訪視日期",
      header: "下次訪視日期",
    },
    {
      key: "訪視區間",
      field: "訪視區間",
      header: "訪視區間",
    },
    {
      key: "個案地址",
      field: "個案地址",
      header: "個案地址",
    },
  ],
};
